import { render, staticRenderFns } from "./ShowMore.vue?vue&type=template&id=df531410&scoped=true&"
import script from "./ShowMore.vue?vue&type=script&lang=js&"
export * from "./ShowMore.vue?vue&type=script&lang=js&"
import style0 from "./ShowMore.vue?vue&type=style&index=0&id=df531410&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df531410",
  null
  
)

export default component.exports